import React from 'react';

import { LinkButton } from '@eika/button';
import { ButtonWithSpinner } from '@eika/button-with-spinner';
import { ConfirmationDialog } from '@eika/confirmation-dialog';

import { UniquePaymentId } from '../../../../generated-types';
import useTranslation from '../../../../hooks/useTranslation';

interface Props {
    outboxItemId: UniquePaymentId;
    onUnapprove: () => void;
    confirmUnapproveState: [boolean, () => void];
    showSpinner: boolean;
}

const UnapproveView: React.FC<Props> = ({
    outboxItemId,
    confirmUnapproveState: [showConfirm, close],
    onUnapprove,
    showSpinner,
}) => {
    const translated = useTranslation();
    return (
        <div className="outbox-item__container">
            <ConfirmationDialog
                title={translated.paymentItem.sureYouWantToUnapprove}
                id={`unapprove-outbox-item-dialog-${outboxItemId.value}`}
                className="action-outbox-item__dialogue"
                footer={
                    <div className="action-outbox-item-button__button-row">
                        <LinkButton disabled={showSpinner} onClick={close}>
                            {translated.cancel}
                        </LinkButton>
                        <ButtonWithSpinner
                            size="small"
                            buttonType="positive"
                            onClick={onUnapprove}
                            showSpinner={showSpinner}
                            data-testid="outbox-confirm-unapprove-button"
                        >
                            {translated.outbox.confirmUnapprove}
                        </ButtonWithSpinner>
                    </div>
                }
                show={showConfirm}
                onExitFocus={close}
                headingLevel={3}
            />
        </div>
    );
};

export default UnapproveView;
